<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_Shopify_SyncDialog_Title')"
    width="500px"
    center
  >
    <el-row type="flex" justify="center">
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="startSync('sync')"
      >
        {{ $t('Integrations_Shopify_SyncDialog_StartSync') }}
      </el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="startSync('sync-profiles')"
      >
        {{ $t('Integrations_Shopify_SyncDialog_StartProfilesSync') }}
      </el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="startSync('sync-purchases')"
      >
        {{ $t('Integrations_Shopify_SyncDialog_StartPurchasesSync') }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'ShopifySyncDialog',

  data() {
    return {
      visible: false,
      syncLoading: false
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    startSync(endpoint) {
      this.syncLoading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `integrations/shopify/${this.$attrs.model.id}/${endpoint}`
        })
      )
        .then(({ data }) => {
          this.syncLoading = false
          this.visible = false
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data.id }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.syncLoading = false
          this.visible = false
        })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/shopify/ShopifySyncDialog.vue